import type React from "react";
import { useTranslation } from "react-i18next";
import type translations from "../../translations/translations.json";
import { TestId } from "../../constants/testIds";
import type { EntityChangeHistoryTestIds } from "../common/EntityChangeHistorySection";
import EntityChangeHistorySection from "../common/EntityChangeHistorySection";
import type { OrderHistory, OrderRevisionNote } from "../../types/order";
import { buildOrderDisplayHistories } from "../../utils/entityChangeHistory";

type TranslationKeys = keyof typeof translations.en;

interface OrderHistorySectionProps {
  histories: OrderHistory[];
  revisionNote?: OrderRevisionNote;
  title?: string;
  testIds?: EntityChangeHistoryTestIds;
  sx?: object;
}

const OrderHistorySection: React.FC<OrderHistorySectionProps> = ({
  histories,
  revisionNote,
  title,
  testIds,
  sx,
}) => {
  const { t } = useTranslation();
  const sortedHistories = buildOrderDisplayHistories(histories, revisionNote);

  return (
    <EntityChangeHistorySection
      title={title ?? t("orders.histories" as TranslationKeys)}
      histories={sortedHistories}
      testIds={
        testIds ?? {
          root: TestId.ORDER.HISTORY,
          entry: TestId.ORDER.HISTORY_ENTRY,
          summary: TestId.ORDER.HISTORY_SUMMARY,
          change: TestId.ORDER.HISTORY_CHANGE,
        }
      }
      sx={sx}
    />
  );
};

export default OrderHistorySection;
